import { authGet } from "@api/auth/auth";
import { Permission } from "@types";

import { ActionResponse } from "@pages/settings/types";

/**
 * Fetch actions from deploymentId provided user has permission
 * Recommended that you use the useActions hook instead of directly calling this function
 */
export const fetchActionsIfPermitted = (
  deploymentId: string,
  permissions: Permission[]
) => {
  if (!permissions.includes(Permission.panel_policy)) {
    return Promise.resolve([]);
  }

  return authGet<ActionResponse[]>(
    `/api/agent/deployments/${deploymentId}/actions`
  );
};
